import { useDispatch } from 'react-redux';
import { deleteUser } from '../../store/slice/userSlice';

import { Link } from 'react-router-dom';

import Button from '../UI/Button';

const UserList = ({ users }) => {
    const dispatch = useDispatch();

    let content = <p className="text-center col-span-2 text-gray-700 font-semibold">No Users</p>;

    const deleteUserHandler = (userId) => {
        dispatch(deleteUser({ id: userId }));
    };

    if (users && users.length > 0) {
        content = (
            users.map(user => (
                <div key={user.id} className="bg-gray-300 p-5 flex item-center justify-between">
                    <div className="">
                        <h3 className="font-bolf text-lg text-gray-700">{user.name}</h3>
                        <span className="font-normal text-gray-600">{user.email}</span>
                    </div>
                    <div className="flex gap-4">
                        <Link to={`users?action=edit&id=${user.id}`}>
                            <button>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
                                </svg>
                            </button>
                        </Link>
                        <Link to="/">
                            <button onClick={() => deleteUserHandler(user.id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                </svg>
                            </button>
                        </Link>
                    </div>
                </div>
            ))
        );
    }

    return (
        <>
            <Link to="users?action=add">
                <Button options={{ type: 'button', classes: 'block mx-auto' }}>Add User</Button>
            </Link>

            <div className="grid gap-5 md:grid-cols-2">
                {content}
            </div>
        </>
    );
};

export default UserList;